export class Orders {
	loadOrder(id, parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'html',
			data: {action: 'loadOrder', id: id},
			success: function(data)
			{
				$('.popup[data-popup-name=popup-cc-order] .popup__container').replaceWith($(data).find('.popup__container'));
				$(".popup[data-popup-name=popup-cc-order]").addClass("active");
				$("body").addClass("no-scroll");
				dragScroll.reset();

				_this.applyEvents();
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	save(id, parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: $(parent).closest('form').serialize() + '&action=save&id=' + id,
			success: function(res)
			{
				if (res.success)
				{
					$('.popup[data-popup-name=popup-cc-order] .popup__container').replaceWith($(res.html).find('.popup__container'));
					
					_this.applyEvents();
					_this.showNotify('Успех', 'Заказ сохранен');
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	accept(id, parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: {action: 'accept', id: id},
			success: function(res)
			{
				if (res.success)
				{
					$('.popup[data-popup-name=popup-cc-order] .popup__container').replaceWith($(res.html).find('.popup__container'));
					
					_this.applyEvents();
					_this.showNotify('Успех', 'Заказ принят');
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	cancel(id, parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: {action: 'cancel', id: id},
			success: function(res)
			{
				if (res.success)
				{
					$('.popup[data-popup-name=popup-cc-order] .popup__container').replaceWith($(res.html).find('.popup__container'));
					
					_this.applyEvents();
					_this.showNotify('Успех', 'Заказ отменен');
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	acceptPay(id, parent)
	{
		let _this = this;
		let paytype = $(parent).closest('.elements-wrapper').find('select').val();
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: {action: 'acceptPay', id: id, paytype: paytype},
			success: function(res)
			{
				if (res.success)
				{
					$('.popup[data-popup-name=popup-cc-order] .popup__container').replaceWith($(res.html).find('.popup__container'));
					
					_this.applyEvents();
					_this.showNotify('Успех', 'Оплата внесена');
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	cancelPay(id, parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: {action: 'cancelPay', id: id},
			success: function(res)
			{
				if (res.success)
				{
					$('.popup[data-popup-name=popup-cc-order] .popup__container').replaceWith($(res.html).find('.popup__container'));
					
					_this.applyEvents();
					_this.showNotify('Успех', 'Оплата отменена');
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	setWas(id, parent)
	{
		let _this = this;
		let was = $(parent).prop('checked') ? 1 : 0;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: {action: 'setWas', id: id, was: was},
			success: function(res)
			{
				if (res.success)
				{
					
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	refuse(id, parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: {action: 'refuse', id: id},
			success: function(res)
			{
				if (res.success)
				{
					$('.tbody-refused').append($(parent).closest('tr'));
					$(parent).closest('tr').find('input').prop('checked', false);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	unrefuse(id, parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: {action: 'unrefuse', id: id},
			success: function(res)
			{
				if (res.success)
				{
					$('.tbody-common').append($(parent).closest('tr'));
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	loadEvents(parent)
	{
		let id = $(parent).closest('.form-multi').find('.form-multi__choice-list li input:checked').val();
		
		if (id)
		{
			let ul = $('#events_select').find('.form-multi__choice-list');

			$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: {action: 'loadEvents', id: id},
			success: function(res)
			{
				ul.html('');
				let field = 'slt_cc_events';
				for (let i = 0; i < res.events.length; i++)
				{
					let li = ul.append('<li class="form-multi__choice-item"><input class="form-multi__choice-input visually-hidden" type="radio" name="' + field + '" id="' + field + '_id' + res.events[i].id +  '" value="' + res.events[i].id +  '"><label class="form-multi__choice-label" for="' + field + '_id' + res.events[i].id +  '">' + res.events[i].name +  '</label></li>');
					li.find('input').on("change", function () {
						$(this).closest(".form-multi").find(".form-multi__top-input").val($(this).siblings(".form-multi__choice-label").text());
						$(".form-multi__top-input").removeClass("active");
						$(".form-multi__choice").removeClass("active");
					});
				}
					
				$('#events_select .form-multi__top-input').prop('disabled', false);
			},
			error: function(e)
			{
				alert(e);
			}
		});
		}
	}

	loadParents(parent)
	{
		let id = $(parent).closest('.form-multi').find('.form-multi__choice-list li input:checked').val();
		
		if (id)
		{
			
			$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: {action: 'loadParents', id: id},
			success: function(res)
			{
				let ul = $('#parents_select').find('.form-multi__choice-list');
				ul.html('');
				let field = 'slt_family';
				for (let i = 0; i < res.parents.length; i++)
				{
					if (res.parents[i].role == 'родитель')
					{
						let li = ul.append('<li class="form-multi__choice-item"><input class="form-multi__choice-input visually-hidden" type="radio" name="' + field + '" id="' + field + '_id' + res.parents[i].id +  '" value="' + res.parents[i].id +  '"><label class="form-multi__choice-label" for="' + field + '_id' + res.parents[i].id +  '">' + res.parents[i].name +  '</label></li>');
						li.find('input').on("change", function () {
							$(this).closest(".form-multi").find(".form-multi__top-input").val($(this).siblings(".form-multi__choice-label").text());
							$(".form-multi__top-input").removeClass("active");
							$(".form-multi__choice").removeClass("active");
						});
					}
				}
					
				$('#events_select .form-multi__top-input').prop('disabled', false);

				ul = $('.family_select').find('.form-multi__choice-list');
				ul.html('');
				field = 'ntd_visitors';
				for (let i = 0; i < res.parents.length; i++)
				{
					let li = ul.append('<li class="form-multi__choice-item"><input class="form-multi__choice-input visually-hidden" type="radio" name="' + field + '[]" id="' + field + '_id' + res.parents[i].id +  '" value="' + res.parents[i].id +  '"><label class="form-multi__choice-label" for="' + field + '_id' + res.parents[i].id +  '">' + res.parents[i].name +  '</label></li>');
					li.find('input').on("change", function () {
						$(this).closest(".form-multi").find(".form-multi__top-input").val($(this).siblings(".form-multi__choice-label").text());
						$(".form-multi__top-input").removeClass("active");
						$(".form-multi__choice").removeClass("active");
					});
				}
					
				$('#events_select .form-multi__top-input').prop('disabled', false);

			},
			error: function(e)
			{
				alert(e);
			}
		});
		}
	}

	submitOrder(parent)
	{
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/19/',
			dataType: 'json',
			data: $(parent).serialize() + '&action=submitOrder',
			success: function(res)
			{
				if (res.success)
				{
					$(parent).html('<h2>Успешно!</h2>');
					location.reload();
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	loadAddVisitorForm(id, client, mode, parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/20/',
			dataType: 'html',
			data: {action: 'loadAddVisitorForm', id: id, client: client, mode: mode},
			success: function(data)
			{
				$('.popup[data-popup-name=popup-cc-visitor-' + mode + '] .popup__container').replaceWith($(data).find('.popup__container'));
				$('.popup[data-popup-name=popup-cc-visitor-' + mode + ']').addClass('active');
				$('body').addClass('no-scroll');
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	addVisitor(parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/20/',
			dataType: 'json',
			data: $(parent).serialize() + '&action=addVisitor',
			success: function(res)
			{
				if (res.success)
				{
					$(parent).html('<h2>Успешно!</h2>');
					location.reload();
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	addAbon(parent)
	{
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/5/',
			dataType: 'json',
			data: $(parent).serialize() + '&action=addAbon',
			success: function(res)
			{
				if (res.success)
				{
					$(parent).html('<h2>Успешно!</h2>');
					location.reload();
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	loadEditAbonForm(id, parent)
	{
		let _this = this;
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/5/',
			dataType: 'html',
			data: {action: 'loadEditAbonForm', id: id},
			success: function(data)
			{
				$('.popup[data-popup-name=popup-cc-edit-abon] .popup__container').replaceWith($(data).find('.popup__container'));
				vform.applyEvents($('.popup[data-popup-name=popup-cc-edit-abon] .popup__container'));
				_this.editAbonFormEvents($('.popup[data-popup-name=popup-cc-edit-abon] .popup__container'));
				$('.popup[data-popup-name=popup-cc-edit-abon]').addClass('active');
				$('body').addClass('no-scroll');
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	editAbonFormEvents(parent)
	{
		$(parent).find('#num_count').on('input', function(){
			let v = $(this).val();
			let b = $(this).closest('form').find('button');
			if (v < 0)
			{
				b.removeClass('btn--Green').addClass('btn--Red').text('Списать');
			}
			else
			{
				b.removeClass('btn--Red').addClass('btn--Green').text('Добавить');
			}
		});
	}

	editAbon(parent)
	{
		$.ajax({
			type: "POST",
			url: '/vsop/ajax/5/',
			dataType: 'json',
			data: $(parent).serialize() + '&action=editAbon',
			success: function(res)
			{
				if (res.success)
				{
					$(parent).html('<h2>Успешно!</h2>');
					location.reload();
				}
				else
				{
					alert(res.error);
				}
			},
			error: function(e)
			{
				alert(e);
			}
		});
	}

	changeAbonPrice(parent)
	{
		let v = $(parent).val();
		let s = 0;

		if (v == 4)
			s = 2900;
		if (v == 8)
			s = 5000;
		if (v == 12)
			s = 6500;

		$(parent).closest('form').find('#num_price').val(s);
	}

	applyEvents()
	{
		$(".popup .popup__close, .popup .popup__cancel").on("click", function(e){
			$("body").removeClass("no-scroll");
			$(this).closest(".popup").removeClass("active");
		});

		$(".popup[data-popup-name=popup-cc-order] form textarea, .popup[data-popup-name=popup-cc-order] form input").on('input', function(){
			$(".popup[data-popup-name=popup-cc-order] .card__actions .save-button").prop('disabled', false);
		});

		$('select.form-select[name="ntd_paytype"]').change(function(){
			let btn = $(this).closest('.elements-wrapper').find('button');
			if ($(this).val())
				btn.prop('disabled', false);
			else
				btn.prop('disabled', true);
		});

		vform.applyEvents($(".popup[data-popup-name=popup-cc-order] form"));
	}

	showNotify(title, text)
	{
		const notifications = $(".notifications")
		const notificationsList = $(".notifications__list")

		$(notifications).addClass("has-new");
		$(notificationsList).prepend(`
			<li class="notifications__item notifications-card">
				<div class="text-block">
					<div class="notifications-card__icon-title">
						<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><path d="M7.75392 16C7.75392 15.317 8.30851 14.7633 8.99266 14.7633H14.7613V9.00392C14.7613 8.32089 15.3159 7.76717 16 7.76717C16.6841 7.76717 17.2388 8.32089 17.2388 9.00392V14.7633H23.0075C23.6916 14.7633 24.2463 15.317 24.2463 16C24.2463 16.683 23.6916 17.2367 23.0075 17.2367H17.2388V22.996C17.2388 23.6792 16.6841 24.2327 16 24.2327C15.3159 24.2327 14.7613 23.6792 14.7613 22.996V17.2367H8.99266C8.30851 17.2367 7.75392 16.683 7.75392 16Z" fill="#002D80"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M8.26484 2.42677C13.3645 1.85774 18.6356 1.85774 23.7351 2.42677C26.7517 2.76337 29.1877 5.13568 29.5427 8.16481C30.1524 13.3705 30.1524 18.6295 29.5427 23.8352C29.1877 26.8644 26.7517 29.2366 23.7351 29.5733C18.6356 30.1422 13.3645 30.1422 8.26484 29.5733C5.24828 29.2366 2.81224 26.8644 2.45738 23.8352C1.84754 18.6295 1.84754 13.3705 2.45738 8.16481C2.81224 5.13568 5.24828 2.76337 8.26484 2.42677ZM23.4599 4.88496C18.5432 4.33632 13.4568 4.33632 8.54002 4.88496C6.64981 5.09586 5.13681 6.58531 4.91811 8.45215C4.33063 13.467 4.33063 18.533 4.91811 23.5479C5.13681 25.4147 6.64981 26.9041 8.54002 27.115C13.4568 27.6636 18.5432 27.6636 23.4599 27.115C25.3502 26.9041 26.8632 25.4147 27.0818 23.5479C27.6693 18.533 27.6693 13.467 27.0818 8.45215C26.8632 6.58531 25.3502 5.09586 23.4599 4.88496Z" fill="#002D80"></path></svg>
						<b>` + title + `</b>
					</div>
					<p>` + text + `</p>
					
				</div>
				<button class="notifications-card__close" type="button" aria-label="закрыть уведомление"></button>
			</li>
		`);
		$(".notifications__item:first-of-type").addClass("new").slideDown();
		setTimeout(function(){
			$(notifications).removeClass("has-new");
		} , 2400);
		setTimeout(function(){
			$(".notifications__item").removeClass("new");
		}, 2800);

		//<p><a class="btn btn--l btn--Green" href="#"><span>Перейти куда-то</span></a></p>
	}
}